
import { useState, useEffect } from 'react';

const TOTAL_CUPOS = 40;
const CUPOS_ACTUALES = 9;

export default function CuposBar() {
  const [visible, setVisible] = useState(false);
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setPulse(true);
      setTimeout(() => setPulse(false), 600);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const porcentajeOcupado = ((TOTAL_CUPOS - CUPOS_ACTUALES) / TOTAL_CUPOS) * 100;

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gray-950 border-t-2 border-red-600 shadow-2xl">
      <div className="container mx-auto px-4 py-2.5 flex flex-col sm:flex-row items-center justify-between gap-2">
        {/* Texto urgencia */}
        <div className="flex items-center gap-3">
          <div className="relative w-3 h-3 flex items-center justify-center">
            <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse" />
            <div className="absolute w-3 h-3 bg-red-500 rounded-full animate-ping" />
          </div>
          <p className="text-white text-sm font-semibold">
            ¡Quedan solo{' '}
            <span
              className={`text-red-400 font-black text-xl transition-all duration-300 ${
                pulse ? 'scale-125 text-red-300' : ''
              }`}
              style={{ display: 'inline-block' }}
            >
              {CUPOS_ACTUALES}
            </span>{' '}
            cupos disponibles!
          </p>
        </div>

        {/* Barra de progreso */}
        <div className="flex items-center gap-3 w-full sm:w-auto sm:min-w-[260px]">
          <div className="flex-1 sm:w-48 bg-gray-700 rounded-full h-2.5 overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-red-600 to-orange-500 rounded-full transition-all duration-1000"
              style={{ width: `${porcentajeOcupado}%` }}
            />
          </div>
          <span className="text-xs text-gray-400 whitespace-nowrap">
            {Math.round(porcentajeOcupado)}% ocupado
          </span>
        </div>

        {/* CTA */}
        <a
          href="https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte"
          target="_blank"
          rel="noopener noreferrer"
          className="whitespace-nowrap px-5 py-2 bg-red-600 hover:bg-red-500 text-white text-sm font-bold rounded-lg transition-all duration-200 hover:scale-105 cursor-pointer"
        >
          Reservar ahora →
        </a>
      </div>
    </div>
  );
}
